<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <p>&nbsp;</p>
        <div class="section-title text-center mb-4 pb-2">
          <h4 class="title mb-4">Our Services</h4>
          <p class="text-muted">
            With strong partnerships around the globe, we are able to offer a number of services to our customers,
            regardless of their country of residence. These services pave the way for our customers to better facilitate
            the movement of their money as well as the purchase of goods and services internationally. Endeavoring to
            increase the number of services we provide to our customers, we constaly seek new international business
            partners to establish a strong global network of payments.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5 col-md-6">
        <img src="assets/images/illustrator/undraw_crypto.svg" class="img-fluid" alt="">
      </div>

      <div class="col-lg-7 col-md-6 mt-4 mt-lg-0 pt- pt-lg-0">
        <div class="ms-lg-4">
          <div class="section-title">
            <span class="badge bg-soft-primary rounded-pill fw-bold">Our Services</span>
            <h4 class="title mt-3">Prima Express</h4>
            <p class="text-muted para-desc">
              Connected Anytime and anywhere. Simple, reliable, and fast transfer.
            </p>
          </div>

          <div class="d-flex mt-4 pt-2">
            <i class='bx bx-money h5 color-brand'></i>
            <div class="flex-1 ms-2">
              <h5>Cash Pick Up</h5>
              <p class="mb-0 text-muted">
                Cash Collection available from thousands of collection points worldwide
              </p>
            </div>
          </div>

          <div class="d-flex mt-4 pt-2">
            <i class='bx bxs-bank h5 color-brand'></i>
            <div class="flex-1 ms-2">
              <h5>Direct to Account</h5>
              <p class="mb-0 text-muted">
                Deposit directly into a designated bank account from hundreds of different banks
              </p>
            </div>
          </div>

          <div class="d-flex mt-4 pt-2">
            <i class='bx bx-globe h5 color-brand'></i>
            <div class="flex-1 ms-2">
              <h5>Instantaneous Transfers</h5>
              <p class="mb-0 text-muted">
                Beneficiaries recieve payment within seconds of remittance
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
